export default class IndexedDB {
    constructor(databaseName, stores, version) {
        this.db = null
        this.databaseName = databaseName
        this.stores = stores
        this.version = version
    }

    openDB(callback=(()=>{})) {
        if (!window.indexedDB) {
        callback({ message: 'Unsupported indexedDB' });
        }
        let request = window.indexedDB.open(this.databaseName, this.version);
    
        request.onsuccess = e => {
            const db = e.target.result;
            db.onversionchange = () => {
                db.close();
            };
            this.db = request.result;
        };
        request.onerror = e => callback(e.target.error);
        request.onupgradeneeded = e => {
            this.db = e.target.result;
            this.db.onabort = e2 => {callback(e2.target.error)};
            this.db.error = e2 => {callback(e2.target.error)};
            this.stores && this.stores.forEach((o) => {
                const store = this.db.createObjectStore(o.name, o.option);
                if (o.indexes) {
                    o.indexes.map(i => store.createIndex(i.name, i.name, {unique: false}))
                }
            });
        };
        callback("db opened successfully")
    }

    add(storeName, data, callback=(()=>{})) {
        if (this.db && data) {
        let transaction = this.db.transaction([storeName], "readwrite");
            transaction.onabort = te => callback(te.target.error);
            transaction.onerror = te => callback(te.target.error);
    
        let request = transaction.objectStore(storeName).add(data)
            request.onerror = e => callback(e.target.error);
            request.onsuccess = e => callback(e.target.result);
        }
    }
    put(storeName, data, callback=(()=>{})) {
        if (this.db && data) {
        let transaction = this.db.transaction([storeName], "readwrite");
            transaction.onabort = te => callback(te.target.error);
            transaction.onerror = te => callback(te.target.error);

        let request = transaction.objectStore(storeName).put(data);
            request.onerror = e => callback(e.target.error);
            request.onsuccess = e => callback(e.target.result);
        }
    }

    delete(storeName, key, callback=(()=>{})) {
        if (this.db) {
        let request = this.db.transaction([storeName], "readwrite").objectStore(storeName).delete(key);
            request.onerror = e => callback(e.target.error);
            request.onsuccess = e => callback(e.target.result);
        }
    }
    get(storeName, key, callback=(()=>{})) {
        if (this.db && key) {
            let request = this.db.transaction([storeName]).objectStore(storeName).get(key)
            request.onerror = e => callback(e.target.error)
            request.onsuccess = e => callback(e.target.result);
        }
    }
    
    async getAll(storeName, callback=(()=>{})) {
        if (this.db) {
        let results = [];
        let request = this.db.transaction(storeName).objectStore(storeName).openCursor(null, IDBCursor.NEXT);
        request.onsuccess = e => {
            let cursor = e.target.result;
            if (cursor) {
            results.push({ [cursor.key]: cursor.value });
            cursor.continue();
            } else {
            callback(results);
            }
        };
        request.onerror = e => callback(e.target.error);
        }
    }

    clear(storeName, callback=(()=>{})) {
        if (this.db) {
        let request = this.db.transaction([storeName], "readwrite").objectStore(storeName).clear();
            request.onerror = e => callback(e.target.error);
            request.onsuccess = e => callback(e.target.result);
        }
    }
    
    count(storeName, callback=(()=>{})) {
        if (this.db) {
        let request = this.db.transaction([storeName]).objectStore(storeName).count();
            request.onerror = e => callback(e.target.error);
            request.onsuccess = e => callback(e.target.result);
        }
    }

    
    createOrUpdate(storeName, data, key, callback=(()=>{})) {
        this.get(storeName, key, record => {            
            if (record) this.put(storeName, data, callback=(()=>{}))
            else this.add(storeName, data, callback=(()=>{}))
        })
    }
}